import React, { FC } from 'react';
import styles from './nav_dropdown_top.module.scss';

export const NavDropdownTop: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
